import { UserRole, FormSubmission, Form } from "@ambii-com/core";
import {
  readAdminByUserId,
  readForm,
  readFormSubmission,
} from "~/services/firestoreReads";

export default async function ({ app, store, redirect, route, from }) {
  // server guard from bug-157
  if (process.server) return

  // skip query-only navs (like the new search query)
  if (from && route.path === from.path) return

  // ==ORDER IS IMPORTANT==
  // 1. wait for firebase session restoration FIRST
  const user: any = await store.dispatch("auth/bootstrap", app)
  // 2. if truly no user, ONLY THEN redirect
  if (!user) {
    return redirect({path: app.localePath("/login"), query: {from: route.fullPath}})
  }
  // 3. make sure store is populated
  if (!store.getters["auth/isLoggedIn"]) {
    await store.dispatch("auth/setUser", user)
  }

  // admin check
  if (!store.getters["auth/checkSuperadmin"]) {
    const adminDoc = await readAdminByUserId(
      store.getters["auth/getUserId"] || user.uid
    )

    if (!adminDoc) {
      alert(app.i18n.t("middleware.pleaseUseAdminAccount"))
      await store.dispatch("auth/logout")
      return redirect({path: app.localePath("/login"), query: {from: route.fullPath}})
    }

    const role = adminDoc.data().role
    const isAdmin = role === UserRole.CLINIC || role === "STAFF"

    if (!isAdmin) {
      alert(app.i18n.t("middleware.pleaseUseAdminAccount"))
      await store.dispatch("auth/logout")
      return redirect({path: app.localePath("/login"), query: {from: route.fullPath}})
    }
  }

  const clinicIdFromStore = store.getters["auth/getClinicId"]

  // submission details page
  if (Object.prototype.hasOwnProperty.call(route.params, "submissionId")) {
    const submissionId = route.params.submissionId
    const submission = await readFormSubmission(submissionId)

    if (clinicIdFromStore && submission.clinicId !== clinicIdFromStore) {
      await store.dispatch("auth/logout")
      return redirect({path: app.localePath("/login"), query: {from: route.fullPath}})
    }
  }

  // form build page
  else if (Object.prototype.hasOwnProperty.call(route.params, "formId")) {
    const formId = route.params.formId
    const form = await readForm(formId)

    if (clinicIdFromStore && form.clinicId !== clinicIdFromStore) {
      await store.dispatch("auth/logout")
      return redirect({path: app.localePath("/login"), query: {from: route.fullPath}})
    }
  }
}
